import { SignUpTypes } from '../constants/common/signUpType';

export const SIGNUP_PARTNER_TYPE_COOKIE_NAME = 'signupPartnerType';

/** Host where the partner-type cookie may be set and read (host-only, not other `*.agoda.com`). */
export const SIGNUP_PARTNER_TYPE_COOKIE_HOST = 'partners.agoda.com';

/** Cookie lifetime after partner-type step (seconds). */
export const SIGNUP_PARTNER_TYPE_COOKIE_MAX_AGE_SEC = 300;


/**
 * Sets a short-lived, host-only cookie on `https://partners.agoda.com/`.
 * Omitting `Domain` scopes the cookie to this host only (not `www.agoda.com`, etc.).
 * No-op on other origins (e.g. localhost) — browsers cannot set `partners.agoda.com` cookies from elsewhere.
 */
export function setSignupPartnerTypeCookie(partnerType: SignUpTypes.Affiliate | SignUpTypes.Ambassador): void {
    if (typeof document === 'undefined') {
        return;
    }
    const value = encodeURIComponent(String(partnerType));
    document.cookie = [
        `${SIGNUP_PARTNER_TYPE_COOKIE_NAME}=${value}`,
        `Max-Age=${SIGNUP_PARTNER_TYPE_COOKIE_MAX_AGE_SEC}`,
        'Path=/',
        'SameSite=Lax',
        'Secure',
    ].join('; ');
}

/** Returns stored partner type if cookie is present and valid, otherwise `null`. */
export function readSignupPartnerTypeCookie(): SignUpTypes.Affiliate | SignUpTypes.Ambassador | null {
    if (typeof document === 'undefined') {
        return null;
    }
    const match = document.cookie.match(
        new RegExp(`(?:^|; )${SIGNUP_PARTNER_TYPE_COOKIE_NAME}=([^;]*)`)
    );
    if (!match?.[1]) {
        return null;
    }
    const n = Number(decodeURIComponent(match[1]));
    if (n === SignUpTypes.Affiliate || n === SignUpTypes.Ambassador) {
        return n;
    }
    return null;
}

/**
 * Returns the server-injected partner type for the current page render
 * (`window.signUpPageParam.signupPartnerType`, populated by
 * `Views/Main/Index.cshtml`). Read this on `/signup`; do not read
 * `document.cookie` from the client — the server is the source of truth.
 */
export function getServerSignupPartnerType(): SignUpTypes.Affiliate | SignUpTypes.Ambassador | null {
    if (typeof window === 'undefined') {
        return null;
    }
    const value = window.signUpPageParam?.signupPartnerType;
    if (value === SignUpTypes.Affiliate || value === SignUpTypes.Ambassador) {
        return value;
    }
    return null;
}
